module.exports = __webpack_public_path__ + "media/photo/electric_bannersss-86d69552.jpg";